import { usePathname } from 'next/navigation';

import { getCountryCode, getLanguageCode } from '../utils/locale/locale.utils';

export const usePathLocale = (): string => {
   const pathname = usePathname();

   return pathname.split('/')[1] ?? '';
};

export const usePathLanguageCode = (): string => getLanguageCode(usePathLocale());

export const usePathCountryCode = (): string => getCountryCode(usePathLocale());
